import { render, staticRenderFns } from "./TagsListAdd.vue?vue&type=template&id=03828398&"
import script from "./TagsListAdd.vue?vue&type=script&lang=js&"
export * from "./TagsListAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports